import React, { Suspense } from 'react';

import SuspenseLoader from './SuspenseLoader';

const SuspenseFallback = ({ children }) => {
  return <Suspense fallback={<SuspenseLoader />}>{children}</Suspense>;
};

export default SuspenseFallback;
